/* eslint-disable react/no-deprecated */
//external imports
import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

//local imports
import store, { persistor } from './store/store';
import { Header, ErrorPage } from './components/';
// import { useAutoZoom } from './hooks/useAutoZoom'; // NOTE: (#3186) auto zoom is currently broken
import { LoadingIndicator } from '@/components/v4';

//style imports
import Themes from './themes/index';
import './index.css';
import { ToastContainer } from 'react-toastify';
import DataRouter from '@/lib/data-router';
import 'react-toastify/dist/ReactToastify.min.css';

function Root() {
    // useAutoZoom(); // NOTE: (#3186) auto zoom is currently broken

    return (
        <Provider store={store}>
            <PersistGate loading={<LoadingIndicator />} persistor={persistor}>
                <Header />
                <Themes>
                    <ErrorBoundary FallbackComponent={ErrorPage}>
                        <ToastContainer
                            theme="colored"
                            autoClose={5000}
                            limit={1}
                        />
                        <DataRouter />
                    </ErrorBoundary>
                </Themes>
            </PersistGate>
        </Provider>
    );
}

ReactDOM.render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>,
    document.getElementById('root'),
);
